/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useQuery, gql } from '@apollo/client';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'recompose';

import { object, shape, string } from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import { getBrand } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { GRAPHQL_ENV } from '../../../../gql';
import SympathyArticleBlock from './SympathyArticleBlock';
import SympathyArticleBlockMobile from './SympathyArticleBlockMobile';
import DesktopMobile from '../../../../helpers/DesktopMobile/DesktopMobile';
import withPageView from '../../../../helpers/tracking/hocs/withPageView';
import { coreBrowsingPageViewSuccessTest } from '../../../../helpers/tracking/common/commonTrackingHelpers';
import GraphqlSeoHeadTags from '../../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import ProductFallbackContainer from '../../GraphqlCommonComponents/GraphqlProductsFallbackContainer/ProductsFallbackContainer';

const SympathyArticlePage = ({ brand, page }) => {
    const SYMPATHY_ARTICLE_PAGE_QUERY = gql`
            query SympathyArticlePageQuery {
                findContentPage(brand: "${brand['domain-name']}", contentType: "${page.contentType}", url: "${page.path}", environment: "${GRAPHQL_ENV}", locale: "en-us") {
                    content
                    brand
                }
            }
        `;
    const { loading, error, data } = useQuery(SYMPATHY_ARTICLE_PAGE_QUERY);
    if (loading) {
        return null; // skeleton component
    }

    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: SYMPATHY_ARTICLE_PAGE_QUERY,
            component: 'SympathyArticlePage.js',
            message: 'Error loading data from Graphql',
            env: GRAPHQL_ENV,
            error,
        });
        return <ProductFallbackContainer />;
    }

    if (!data || !data.findContentPage.content || !data.findContentPage.content.entries.length) {
        if (!data) {
            mbpLogger.logWarning({
                appName: process.env.npm_package_name,
                query: SYMPATHY_ARTICLE_PAGE_QUERY,
                component: 'SympathyArticlePage.js',
                message: 'No data returned for query',
                env: GRAPHQL_ENV,
            });
        } else if (!data.findContentPage.content) {
            mbpLogger.logWarning({
                appName: process.env.npm_package_name,
                query: SYMPATHY_ARTICLE_PAGE_QUERY,
                component: 'SympathyArticlePage.js',
                message: 'No content returned for query',
                env: GRAPHQL_ENV,
            });
        } else if (!data.findContentPage.content.entries.length) {
            mbpLogger.logWarning({
                appName: process.env.npm_package_name,
                query: SYMPATHY_ARTICLE_PAGE_QUERY,
                component: 'SympathyArticlePage.js',
                message: 'No content entries returned for query',
                env: GRAPHQL_ENV,
            });
        }
        return <ProductFallbackContainer />;
    }
    let SympathyArticleData = null;
    if (data.findContentPage.content !== null) {
        if (data.findContentPage.content.entries.length > 0) {
            SympathyArticleData = data.findContentPage.content.entries[0];
        }
    }
    return (
        <>
            <><GraphqlSeoHeadTags seoData={SympathyArticleData.seo} />
                <DesktopMobile
                    breakpoint={767}
                    desktop={() => <SympathyArticleBlock data={SympathyArticleData} />}
                    mobile={() => <SympathyArticleBlockMobile data={SympathyArticleData} />}
                />
            </>
        </>
    );
};

SympathyArticlePage.propTypes = {
    brand: object.isRequired,
    page: shape({
        contentType: string.isRequired,
        path: string.isRequired,
    }).isRequired,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

const enhance = compose(
    withRouter,
    withPageView({
        pageViewSuccessTest: () => coreBrowsingPageViewSuccessTest,
    }),
    connect(mapStateToProps),
);

export default enhance(SympathyArticlePage);
